/** @jsx jsx */
import { css } from '@emotion/react';

export const commonStyles = {
  hint: css`
    color: var(--cds-color-neutral-primary-weak);
    font-size: 12px;
    line-height: 18px;
    margin-top: 8px;
  `,
};
